/**
 * @flow
 * @author: VaraKumar
 */

import styled from 'react-emotion'

import { desktop } from '../../../../../utils/mixins'

export const AlignTwoChildrenInRowRowBlock = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  ${desktop} {
    padding-bottom: ${props => (props.excludeBottomMargin ? 0 : '0.9375em')};
  }
`

export const AlignTwoChildrenInRowChild = styled('div')`
  display: flex;
  flex-direction: column;
  width: ${props => (props.customWidth ? props.customWidth : '50%')};
`



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/AlignTwoChildrenInRow/styledComponents.js